module.exports = __webpack_public_path__ + "img/abraham-doras-shadd.1cf62c38.png";